import {
  Button,
  CircularProgress,
  Container,
  Drawer,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useGetHistorialBLQuery } from "../../../services/historial-bl/historialBlService";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@material-ui/lab";
import {
  IconCalendar,
  IconClock,
  IconEye,
  IconListDetails,
} from "@tabler/icons-react";
import { format } from "date-fns";
import { Historial } from "../../../interfaces/historial-bl/historial.bl.interface";
import DialogHistorialBl from "../../historial-bl/components/DialogHistorialBl";

interface props {
  idBl: number;
  onClose: () => void;
}

const DrawerHistoryBl = ({ idBl, onClose }: props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [historial, setHistorial] = useState<Historial | undefined>();

  const { isLoading, data, error } = useGetHistorialBLQuery(
    {
      id_bl: idBl,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      onClose();
    }, 500);
  };

  const handleCloseDialog = () => {
    setHistorial(undefined);
  };

  useEffect(() => {
    if (idBl !== undefined) {
      setIsOpen(true);
    }
  }, [idBl]);

  return (
    <>
      <Drawer open={isOpen} anchor="right" onClose={handleClose}>
        <Container
          style={{
            height: "100%",
            position: "relative",
          }}
        >
          <Grid container style={{ width: 400 }}>
            <Grid
              item
              xs={12}
              style={{
                height: 50,
                display: "flex",
                alignItems: "center",
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <Typography variant="h5">Historial Bl</Typography>
            </Grid>
            <Grid item xs={12}>
              {isLoading ? (
                <div style={{}}>
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {error !== undefined ? "Error al obtener historial" : null}
                  {data !== undefined ? (
                    <>
                      {data.data.length === 0 ? <EmptyHistory /> : null}
                      <Timeline align="alternate">
                        {data?.data.map((element, index) => (
                          <TimelineItem key={index}>
                            <TimelineSeparator>
                              <TimelineDot
                                color="primary"
                                style={{
                                  boxShadow: "1px 1px 12px dodgerblue",
                                }}
                              />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Paper
                                variant="outlined"
                                elevation={8}
                                style={{ padding: 10 }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <IconCalendar size={16} color="grey" /> &nbsp;
                                  {format(
                                    new Date(element.fecha_modificacion),
                                    "dd/MM/yyyy"
                                  )}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <IconClock size={16} color="grey" /> &nbsp;
                                  {format(
                                    new Date(element.fecha_modificacion),
                                    "HH:mm"
                                  )}
                                </div>

                                <Button
                                  style={{ marginTop: 10 }}
                                  startIcon={<IconEye />}
                                  size="small"
                                  variant="contained"
                                  fullWidth
                                  onClick={() => {
                                    setHistorial(element);
                                  }}
                                >
                                  Ver
                                </Button>
                              </Paper>
                            </TimelineContent>
                          </TimelineItem>
                        ))}
                      </Timeline>
                    </>
                  ) : null}
                </>
              )}
            </Grid>
          </Grid>
        </Container>
      </Drawer>
      <DialogHistorialBl historial={historial} onClose={handleCloseDialog} />
    </>
  );
};

export default DrawerHistoryBl;

const EmptyHistory = () => {
  return (
    <>
      <div
        style={{
          border: "1px solid gainsboro",
          borderRadius: "10px",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <IconListDetails color="grey" />
        <p>No hay datos que mostrar</p>
      </div>
    </>
  );
};
